import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import ErrorModal from "../modals/ErrorModal";
import {
  PRIVACY_POLICY,
  PRIVACY_POLICY_URL,
  PRIVACY_POLICY_LINKS,
} from "../../locales/privacy-policy";

// Popup แสดง "หนังสือแจ้งรายละเอียดการเก็บรวบรวม ใช้และเปิดเผยข้อมูลส่วนบุคคล"
// เป็น informational modal (รับทราบ) — โครงเดียวกับ termRegister.js
const PrivacyPolicyRegister = ({ show, onClose }) => {
  const { t, i18n } = useTranslation();
  const [content, setContent] = useState("");
  const [error, setError] = useState(null);
  const scrollRef = useRef(null);

  useEffect(() => {
    const lang = i18n.language.toLowerCase();
    if (PRIVACY_POLICY[lang]) {
      setContent(PRIVACY_POLICY[lang]);
    } else {
      setContent(PRIVACY_POLICY.th);
    }
  }, [i18n.language]);

  useEffect(() => {
    if (show && scrollRef.current) {
      scrollRef.current.scrollTop = 0;
    }
  }, [show]);

  if (!show) return null;
  if (error) return <ErrorModal error={error} onClose={onClose} />;
  if (!content) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg max-w-md w-full p-6 shadow-lg relative">
        <button
          className="absolute top-2 right-3 text-gray-500 hover:text-gray-700 text-xl"
          onClick={onClose}
        >
          &times;
        </button>
        <h3 className="text-xl font-semibold mb-4">{t("terms_text_4")}</h3>

        {/* Scrollable content */}
        <div
          ref={scrollRef}
          className="overflow-y-auto max-h-[50vh] mb-4 text-base text-left"
        >
          <div
            className="whitespace-pre-wrap"
            dangerouslySetInnerHTML={{ __html: content }}
          />

          {/* นโยบายย่อยแยกตามประเภทลูกค้า */}
          <div className="mt-4 border-t pt-3">
            {PRIVACY_POLICY_LINKS.map((item) => (
              <a
                key={item.url}
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary underline block mb-2 text-sm"
              >
                {item.label}
              </a>
            ))}
          </div>

          {/* ลิงก์ไปฉบับเต็มที่ bigc.co.th */}
          <a
            href={PRIVACY_POLICY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary underline block mt-2 text-sm"
          >
            {t("privacy_read_full", "อ่านฉบับเต็มที่ bigc.co.th")}
          </a>
        </div>

        {/* Acknowledge Button */}
        <div className="flex justify-center">
          <button
            className="px-6 py-2 rounded-full text-white bg-primary transition-all duration-300"
            onClick={onClose}
          >
            {t("acknowledge", "รับทราบ")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyRegister;
